<template>
<div>
  <input
    class="m-2 tc-wd-word-input"
    :style="inputWidth"
    :maxlength="maxLength" 
    @input="$emit('input', $event.target.value)" 
    v-on:keyup="onKeyup"
    :value="value"
    :placeholder="hint ? hintValue : ''"
    ref="myInput" 
    />
</div>
</template>

<script>

export default {
  components: {
    
  },
  props: {
    hintValue: String,
    value: String,
    index: Number,
    hint: Boolean
  },
  computed: {
    myInput () {
      return this.$refs.myInput
    },
    maxLength () {
      return this.hintValue.length
    },
    inputWidth () {
      const len = this.hintValue.length
      const diff = len - 4
      if (diff > 0) {
        const width = `width:${  80 + (diff * 16)  }px`
        return width
      } else {
        return 'width:80px'
      }
    }
  },

  data () {
    return {
    }
  },
  methods: {
    onKeyup (e) {

      if (e.keyCode === 8) {
        this.$emit('onBack', this.index)
      } else if (e.keyCode === 13) {
        console.log('enter')
        this.$emit('onEnter', this.index)
      } else if (e.keyCode < 65 || e.keCode > 122) {
        //
      } else {
        this.$emit('onKeyup', this.index)
      }
    },
    focus () {
      this.myInput.focus()
    },
    inputClass () {
      if (this.hintValue.length === 1) {
        return 'm-2 tc-wd-input'
      } else {
        return 'm-2 tc-wd-input'
      }
    }
  },
  mounted () {
    
  }
}

</script>
